import React, { useEffect, useRef, useState } from "react"
import { Tooltip } from "reactstrap"
import "./copyContact.scss"

export default function CopyContact({ value, label, icon }) {
  const button = useRef(null)
  const timer = useRef(null)
  const mounted = useRef(true)
  const [feedback, setFeedback] = useState({ pending: false, message: "" })

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
      clearTimeout(timer.current)
    }
  }, [])

  const copy = async () => {
    if (feedback.pending) return
    clearTimeout(timer.current)
    setFeedback({ pending: true, message: "" })
    let message
    try {
      await navigator.clipboard.writeText(String(value))
      message = "Copied to clipboard"
    } catch {
      message = "Copy failed. Select the text and copy it manually."
    }
    if (!mounted.current) return
    setFeedback({ pending: false, message, open: true })
    timer.current = setTimeout(() => setFeedback(current => ({ ...current, open: false })), 1000)
  }

  return <div className="copy-contact-wrapper">
    <button ref={button} type="button" className="copy-contact"
      aria-label={`Copy ${label}: ${value}`}
      disabled={feedback.pending} aria-busy={feedback.pending} onClick={copy}>
      {icon && <i className={icon} aria-hidden="true" />}
      <span>{value}</span>
    </button>
    <span className="sr-only" role="status">{feedback.open ? feedback.message : ""}</span>
    {feedback.message && <Tooltip target={button} isOpen={feedback.open} placement="top" trigger="manual">
      {feedback.message}
    </Tooltip>}
  </div>
}
